import React, { useState, useEffect } from "react";
import "./basketballbday.css";

import home_background1 from "../../Assets/Images/home/banner.png";
import bday_banner from "../../Assets/Images/BasketBallBday/bday_bg_1.png";
import bday_pics from "../../Assets/Images/BasketBallBday/bday_pics.png";

import StaticPageHeaders from "../../Components/StaticPageHeaders";
import UnlimitedBannerCom from "../../Components/InstructionsCom/UnlimitedBannerCom";
import Gallery from "../../Components/Home/Gallery/Gallery";
import Sponsors from "../../Components/Home/Sponsers/Sponsers";
import BdayBanner from "../../Components/BasketBallBday/BdayBanner/BdayBanner";
import BasketBallBdayBlock from "../../Components/BasketBallBday/BasketBallBdayBlock/BasketBallBdayBlock";
import FloatingRegisterButton from "../../Components/BasketBallBday/FloatingRegisterButton/FloatingRegisterButton";
import SEO from "../../Components/SEO";

import { useNavigate } from "react-router-dom";

const BasketBallBday = () => {
  const navigate = useNavigate();
  const images = [home_background1];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <>
      <SEO
        title="Birthday Parties Registration Form - Shootin School Basketball"
        description=""
        url="https://shootinschool.com/birthday-parties-registration-form/"
      />

      <StaticPageHeaders title="BASKETBALL Birthday Parties" />
      <div
        style={{ "--br-value": 1.28, position: "relative" }}
        className="bday-page bg-custom brightness"
      >
        <BdayBanner />

        <div className="bday-container">
          <div className="bday-sss-layout">
            <div className="sss-grid" style={{ paddingTop: "30px" }}>
              <img src={bday_pics} alt="" style={{ width: "100%" }} />
            </div>
          </div>
        </div>

        <div
          className="bday-container"
          style={{ paddingBottom: "100px", paddingTop: "100px" }}
        >
          <div className="bday-sss-layout">
            <div className="sss-grid" style={{ paddingTop: "30px" }}>
              <BasketBallBdayBlock
                buttonLink="/birthday-parties/"
                buttonText="Register Now"
              />
            </div>
          </div>
        </div>

        <UnlimitedBannerCom bg={bday_banner} />
        <Gallery />
      </div>
      <Sponsors />
      <FloatingRegisterButton />
    </>
  );
};

export default BasketBallBday;
